import Konva from 'konva';
import LabelledCircle from "./LabelledCircle.js";

export default class JugglerView extends Konva.Group {
    constructor(id, onDoubleClick) {
        super();
        this.id = id;
        this.label = new LabelledCircle({
          radius: 30,
          fill: "white",
          stroke: "white",
          strokeWidth: 3,
          text: this.abbrJugglerName(),
          fontSize: 30,
          visible: true,
        });
        this.add(this.label);
        this.onDoubleClick = onDoubleClick;
        this.label.on("dblclick dbltap", () => this.onDoubleClick(this.id));

        this.tooltip = new Konva.Label({ visible: false });
        this.tooltip.add(
            new Konva.Tag({
                fill: 'black',
                pointerDirection: 'left',
                pointerWidth: 20,
                pointerHeight: 10,
                lineJoin: 'round',
                cornerRadius: 7,
            })
        );
        this.tooltip.add(
            new Konva.Text({
                text: '',
                fontSize: 18,
                padding: 5,
                fill: 'white',
            })
        );

        this.add(this.tooltip);

        // Hover events
        this.label.on('mousemove', (event) => {
            const tooltipText = this.tooltip.findOne('Text');
            tooltipText.text(this.name());
            this.tooltip.position({
                x: event.evt.layerX - this.x(),
                y: event.evt.layerY - this.y(),
            });
            this.tooltip.show();
            this.getLayer().batchDraw();
        });

        this.label.on('mouseout', () => {
            this.tooltip.hide();
            this.getLayer().batchDraw();
        });
    }

    name(name) {
      if (name) {
        this._name = name;
        this.label.text(this.abbrJugglerName());
      }
      return this._name || String.fromCharCode('A'.charCodeAt() + this.id);
    }

    abbrJugglerName() {
      return this.name().substring(0, 1);
    }
};
